/* eslint-disable no-unused-vars */
export enum GameState {
    RUNNING = 'running',
    TESTING = 'testing',
    APPROVAL = 'approval'
}
